import { getAllActiveEvent } from "@/services/event.services";
import { createSlice } from "@reduxjs/toolkit";

export interface IEventDetails {
  ID?: number | null;
  Title: string;
  URL: string;
  ShortDescription: string;
  LongDescription: string;
  Tagline: string;
  PackageHighlights: string;
  Inclusion: string;
  Exclusion: string;
  MainImage: string;
  BannerImage: string;
  ImageGallery: any[];
  MetaTitle: string;
  MetaKeywords: string;
  MetaDescription: string;
  RomanticSettings: string;
  GuestCapacity: string;
  CustomPackages: string;
}

export interface IEvent {
  ID: number | null;
  Title: string;
  URL: string;
  ShortDescription: string;
  LongDescription: string;
  Tagline: string;
  PackageHighlights: string;
  Inclusion: string;
  Exclusion: string;
  MainImage: string;
  BannerImage: string;
  ImageGallery: any[];
  MetaTitle: string;
  MetaKeywords: string;
  MetaDescription: string;
  RomanticSettings: string;
  GuestCapacity: string;
  CustomPackages: string;
}

export interface IEventInitialState {
  loading: boolean;
  error: string;
  EventDetails: IEventDetails;
  EventList: IEvent[];
}

const initialState: IEventInitialState = {
  loading: false,
  error: "",
  EventDetails: {
    Title: "",
    URL: "",
    ShortDescription: "",
    LongDescription: "",
    Tagline: "",
    PackageHighlights: "",
    Inclusion: "",
    Exclusion: "",
    MainImage: "",
    BannerImage: "",
    ImageGallery: [],
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    RomanticSettings: "",
    GuestCapacity: "",
    CustomPackages: "",
  },
  EventList: [],
};

const EventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveEvent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveEvent.fulfilled, (state, action) => {
      state.loading = false;
      state.EventList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveEvent.rejected, (state, action) => {
      state.loading = false;
      state.EventList = initialState.EventList;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default EventSlice.reducer;
